import { Check, Copy } from 'lucide-react';
import { IconButton, cn, useToast } from '@eombor/ui';
import { t } from '../i18n/index.js';
import { useCopyToClipboard } from './useCopyToClipboard.js';

export interface CopyButtonProps {
  /** Clipboard ga tushadigan XOM qiymat — ekranda bezalgan bo'lsa ham. */
  value: string;
  /** «Loginni nusxalash» — ekran o'qigich uchun harakatning nomi. */
  label: string;
  className?: string;
}

/**
 * Qiymat yonidagi kichik nusxalash tugmasi.
 *
 * Sichqoncha bilan belgilash ISHLAYDI va u zaxira yo'l bo'lib qoladi; bu
 * tugma esa asosiy yo'l: JSHSHIR va login boshqa tizimlarga ko'chiriladi va
 * 14 xonali raqamni qo'lda terish — xato manbai.
 *
 * KO'RINISHI: hover qilinadigan qurilmada tugma odatda ko'rinmaydi va katak
 * ustiga kelganda chiqadi — o'nlab qatorda doim turgan o'nlab ikonka
 * jadvalni shovqinga to'ldiradi. Barmoq bilan ishlaydigan qurilmada hover
 * degan narsa yo'q, shuning uchun u yerda tugma DOIM ko'rinadi. Klaviatura
 * bilan yurganda ham ko'rinadi (`focus-visible`), aks holda tugmaga
 * yetib borgan odam uni ko'rmasdi.
 *
 * Katakning o'zida `group/copy` sinfi bo'lishi kerak.
 */
export const CopyButton = ({ value, label, className }: CopyButtonProps) => {
  const { copy, copied } = useCopyToClipboard();
  const toast = useToast();

  return (
    <IconButton
      icon={
        copied ? (
          <Check size={13} aria-hidden className="text-success" />
        ) : (
          <Copy size={13} aria-hidden />
        )
      }
      label={label}
      onClick={() => {
        void copy(value).then((ok) => {
          // Muvaffaqiyatsiz nusxalash JIM qolmaydi: "nusxalandi" degan
          // yolg'on xabar odamni qiymatni qo'lda ko'chirmaslikka
          // ishontirardi va u bo'sh clipboard bilan ketardi.
          toast.show(ok ? t('copy.done') : t('copy.failed'), ok ? 'success' : 'danger');
        });
      }}
      className={cn(
        'size-7 shrink-0 text-text-faint',
        // 44×44 BOSILADIGAN maydon — ko'rinishi kichik qolgani holda.
        // Tugmaning o'zini kattalashtirish zich jadvalda qator balandligini
        // surib yuborardi (qator 52px, katak to'ldirmasi bilan 40px joy bor).
        'relative before:absolute before:top-1/2 before:left-1/2 before:size-11',
        'before:-translate-x-1/2 before:-translate-y-1/2 before:content-[""]',
        'opacity-0 transition-opacity duration-[var(--motion-fast)] ease-[var(--ease-standard)]',
        'group-hover/copy:opacity-100 focus-visible:opacity-100',
        // Nusxalangani KO'RINIB tursin — sichqoncha katakdan chiqib ketsa ham.
        copied ? 'opacity-100' : undefined,
        // Hover yo'q qurilmada (barmoq) tugma doim ko'rinadi.
        '[@media(hover:none)]:opacity-100',
        'motion-reduce:transition-none',
        className,
      )}
    />
  );
};
